import { WindowEventQueue } from "@utils/window-event-queue";
import { EVENT_CLOSE_NOTIFICATION_DRAWER, EVENT_OPEN_NOTIFICATION_DRAWER } from "../constants";

export const openNotificationDrawerEventQueue = new WindowEventQueue<void>(EVENT_OPEN_NOTIFICATION_DRAWER);

export function openNotificationDrawer() {
  openNotificationDrawerEventQueue.queueOrDispatch();
}

export function closeNotificationDrawer() {
  window.dispatchEvent(new CustomEvent(EVENT_CLOSE_NOTIFICATION_DRAWER));
}
